import type libphonenumber from "google-libphonenumber";

type PhoneUtilInstance = ReturnType<typeof libphonenumber.PhoneNumberUtil.getInstance>;

let cached: { phoneUtil: PhoneUtilInstance; libpn: typeof libphonenumber } | null =
  null;
let pending: Promise<{
  phoneUtil: PhoneUtilInstance;
  libpn: typeof libphonenumber;
}> | null = null;

export function getPhoneUtil() {
  if (cached) return Promise.resolve(cached);
  if (pending) return pending;
  pending = import("google-libphonenumber").then((mod) => {
    const libpn = (mod as { default?: typeof libphonenumber }).default ??
      (mod as unknown as typeof libphonenumber);
    cached = {
      phoneUtil: libpn.PhoneNumberUtil.getInstance(),
      libpn,
    };
    return cached;
  });
  return pending;
}
